// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderServices/stylesheet/style.scss
 ** module id = 431
 ** module chunks = 1
 **/